// In CardData.js
export const cardData = [
  {
    id: 1,
    image: require('../../assets/card1.png'),
    title: "Our Mission",
    text: "Miami Home Holdings is a Miami-based Real Estate Group, serving South Florida markets. We focus on developing, flipping, remodeling, interior design, and investment opportunities. Our mission is to fix, flip, develop, and remodel as many homes as possible while positively leaving our mark on people & architecture.",
    reverse: false, 
  },
  {
    id: 2,
    image: require('../../assets/card2.png'),
    title: "Our Team",
    text: "Our team is comprised of seasoned professionals, including CRE investors, real estate lawyers, and brokers. With over 75 years of combined experience, we bring a wealth of knowledge to every project. Our diverse backgrounds enable us to find the best deals, ensuring success in all aspects of property development, flipping, and investment opportunities.",
    reverse: true,
  },
  {
    id: 3,
    image: require('../../assets/card3.png'),
    title: "Our Services",
    text: "We specialize in flipping homes to revitalize neighborhoods and create value. We also offer seller financing to help buyers achieve homeownership, making the process easier and more accessible. Whether you're looking to purchase a newly remodeled property or need assistance with creative financing options, our team is here to provide tailored solutions that meet your needs.",
    reverse: false, 
  }
];
